@if (center$ | async; as center) {
  <div class="w-full mt-3">
    <div class="w-full mt-3">
      <app-center-basic-infos
        [center]="center"
      ></app-center-basic-infos>
    </div>
    <div class="flex flex-wrap">
      <div class="w-full xl:w-8 xl:pr-2 mt-3">
        <app-organization-administration-addresses-tile
          [addresses]="center.addresses || []"
          [centerId]="center.id"
        ></app-organization-administration-addresses-tile>
      </div>
      <div class="w-full xl:w-4 xl:pl-2 mt-3">
        <app-organization-contact-persons-table
          [centerId]="center.id"
        ></app-organization-contact-persons-table>

        @if (featureOn.SERVICE_CENTER_MANAGER) {
          <div class="mt-3">
            <app-card [title]="'organization.centerManagers.title'" titleSize="large">
              <ng-template #content>
                @if (usersScroll()) {
                  <div class="flex flex-column gap pt-2">
                    <app-multi-select-input
                      [form]="managersForm"
                      [infiniteScroll]="usersScroll()"
                      id="userIds"
                      valueKey="id"
                      labelKey="name"
                      dataKey="id"
                      display="chip"
                      filterBy="name,surname,email"
                      label="organization.centerManagers.label"
                      [showClear]="true"
                    >
                      <ng-template #item let-item>
                        {{ item | formatPerson }}
                      </ng-template>
                      <ng-template #selectedItems let-items>
                        @for (item of items; track item.id) {
                          {{ item | formatPerson }}@if (!$last) {, }
                        }
                      </ng-template>
                    </app-multi-select-input>

                    <div class="flex justify-content-end">
                      <app-save-button
                        [disabled]="!managersForm.dirty"
                        (clickEvent)="saveManagers(center.id)"
                      ></app-save-button>
                    </div>
                  </div>
                }
              </ng-template>
            </app-card>
          </div>
        }
      </div>
    </div>
  </div>
}
